export function HomeIcon({ color = "#5B616D" }) {
    return (
        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2.69L15 7.19V15H13V9H7V15H5V7.19L10 2.69ZM10 0L0 9H3V17H9V11H11V17H17V9H20L10 0Z"
                  fill={color} />
        </svg>
    );
}

export function FavoritesIcon({ color = "#5B616D" }) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.5 0.824951C12.76 0.824951 11.09 1.63495 10 2.91495C8.91 1.63495 7.24 0.824951 5.5 0.824951C2.42 0.824951 0 3.24495 0 6.32495C0 10.105 3.4 13.185 8.55 17.865L10 19.175L11.45 17.855C16.6 13.185 20 10.105 20 6.32495C20 3.24495 17.58 0.824951 14.5 0.824951ZM10.1 16.375L10 16.475L9.9 16.375C5.14 12.065 2 9.21495 2 6.32495C2 4.32495 3.5 2.82495 5.5 2.82495C7.04 2.82495 8.54 3.81495 9.07 5.18495H10.94C11.46 3.81495 12.96 2.82495 14.5 2.82495C16.5 2.82495 18 4.32495 18 6.32495C18 9.21495 14.86 12.065 10.1 16.375Z"
                fill={color} />
        </svg>
    );
}

export function RecentIcon({ color = "#5B616D" }) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z"
                fill={color} />
        </svg>
    );
}

export function TrashIcon({ color = "#5B616D" }) {
    return (
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z"
                fill={color} />
        </svg>
    );
}

export function SearchIcon({ color = "#5B616D" }) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.755 11.255H11.965L11.685 10.985C12.665 9.845 13.255 8.365 13.255 6.755C13.255 3.165 10.345 0.255005 6.755 0.255005C3.165 0.255005 0.255005 3.165 0.255005 6.755C0.255005 10.345 3.165 13.255 6.755 13.255C8.365 13.255 9.845 12.665 10.985 11.685L11.255 11.965V12.755L16.255 17.745L17.745 16.255L12.755 11.255ZM6.755 11.255C4.26501 11.255 2.255 9.245 2.255 6.755C2.255 4.26501 4.26501 2.255 6.755 2.255C9.245 2.255 11.255 4.26501 11.255 6.755C11.255 9.245 9.245 11.255 6.755 11.255Z"
                fill={color}/>
        </svg>
    )
}

export function ExplorerIcon({ color = "#5B616D" }) {
    return (
        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.13 0.84C14.77 0.33 14.17 0 13.5 0L2.5 0.0100002C1.4 0.0100002 0.5 0.9 0.5 2V12C0.5 13.1 1.4 13.99 2.5 13.99L13.5 14C14.17 14 14.77 13.67 15.13 13.16L19.5 7L15.13 0.84ZM13.5 12H2.5V2H13.5L17.05 7L13.5 12Z"
                fill={color}/>
        </svg>
    )
}

export function CreateSpaceIcon({ color = "#6B7280" }) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4V16M4 10H16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export const FolderPlusIcon = ({ className }) => (
    <svg 
        className={className} 
        viewBox="0 0 32 35" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M16 16.0417V24.7917M12 20.4167H20M29.3333 27.7083C29.3333 28.4819 29.0524 29.2237 28.5523 29.7707C28.0522 30.3177 27.3739 30.625 26.6667 30.625H5.33333C4.62609 30.625 3.94781 30.3177 3.44772 29.7707C2.94762 29.2237 2.66667 28.4819 2.66667 27.7083V7.29167C2.66667 6.51812 2.94762 5.77625 3.44772 5.22927C3.94781 4.68229 4.62609 4.375 5.33333 4.375H12L14.6667 8.75H26.6667C27.3739 8.75 28.0522 9.05729 28.5523 9.60427C29.0524 10.1513 29.3333 10.8931 29.3333 11.6667V27.7083Z" 
            stroke="currentColor" 
            strokeWidth="4" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
);
export function BulletListIcon({ color = "#6B7280" }) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5h12M6 10h12M6 15h12M2 5h.01M2 10h.01M2 15h.01" 
                stroke={color} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"/>
        </svg>
    );
}
